import { useState, createContext, useEffect, ReactNode } from 'react';
import { PoolInfo } from '@/types/pool';
import { getPoolInfoV3 } from '@/services/pool';
import { useParams } from '@web3/base-hooks';
import { useStakingStore } from '@/store/staking';

export const PoolInfoContext = createContext<{
  poolInfo: PoolInfo;
  isFetching: boolean;
}>({
  poolInfo: {} as PoolInfo,
  isFetching: true,
});

PoolInfoContext.displayName = 'PoolInfoContext';
interface Props {
  children: ReactNode;
  id?: string;
}

export const PoolInfoProvider = (props: Props) => {
  const { slug = [] } = useParams();
  const poolId = slug[0];
  const { setOffline } = useStakingStore();
  const { children, id } = props;
  const [poolInfo, setPoolInfo] = useState<PoolInfo>();
  const [isFetching, setIsFetching] = useState(true);

  const fetchPoolInfo = async () => {
    const actualId = poolId ?? id ?? '';
    const { result, success } = await getPoolInfoV3(actualId);

    if (success) {
      setPoolInfo(result);
      setIsFetching(false);
      setOffline(result.offline);
    }
  };

  useEffect(() => {
    if (!poolId && !id) return;
    fetchPoolInfo();
  }, [poolId, id]);

  return (
    <PoolInfoContext.Provider
      value={{
        poolInfo: poolInfo as PoolInfo,
        isFetching,
      }}
    >
      {children}
    </PoolInfoContext.Provider>
  );
};
